<script setup lang="ts">
import type { FormError, FormSubmitEvent } from "#ui/types";
import type { SendHelpRequest } from "~/types/server/requests";
const { sendHelpRequest, userName, userLastName, userMail } = useProfile();
const route = useRoute();
const request: Ref<SendHelpRequest> = ref({
  from: `${userName.value} ${userLastName.value} <${userMail.value}>`,
  type: "",
  message: "",
  referer: route.fullPath,
});
const is_submitting = ref(false);
const submitted = ref(false);
const success = ref(false);

const toast = useToast();

async function onSubmit(event: FormSubmitEvent<any>) {
  is_submitting.value = true;
  const r = await sendHelpRequest(event.data);
  success.value = r.status === 200;
  if (success.value) {
    toast.add({ title: "Messaggio inviato", icon: "i-heroicons-check-circle" });
  } else {
    toast.add({
      color: "red",
      title: "Impossibile inviare il messaggio.",
      description: "Si è verificato un problema durante l'invio",
      icon: "i-heroicons-x-circle",
    });
  }
  is_submitting.value = false;
  submitted.value = true;
}

const options = [
  {
    value: "bug",
    label: "Segnala un problema tecnico",
  },
  {
    value: "info",
    label: "Richiedi informazioni",
  },
  {
    value: "taxcode",
    label: "Richiesta cambio gestore ente / Codice fiscale occupato",
  },
  {
    value: "other",
    label: "Altro",
  },
];

const validate = (request: any): FormError[] => {
  const errors = [];
  if (!request.type)
    errors.push({ path: "type", message: "Seleziona la tematica" });
  if (!request.message)
    errors.push({ path: "message", message: "Inserisci il messaggio" });
  return errors;
};
</script>

<template>
  <UForm
    v-if="!submitted"
    :state="request"
    :validate="validate"
    @submit="onSubmit"
  >
    <div class="flex gap-3 flex-col">
      <UFormGroup name="type" label="Tematica" class="grid grid-cols-1 gap-2">
        <USelect
          v-model="request.type"
          placeholder="Seleziona una voce"
          option-attribute="label"
          color="primary"
          variant="outline"
          :options="options"
        />
      </UFormGroup>

      <UFormGroup name="referer" label="Referer">
        <UInput v-model="request.referer" type="hidden" />
      </UFormGroup>
      <UFormGroup
        name="message"
        label="Messaggio"
        class="grid grid-cols-1 gap-2"
      >
        <UTextarea
          v-model="request.message"
          placeholder="Scrivi qui il tuo messaggio"
          :rows="5"
          autoresize
          size="md"
        />
      </UFormGroup>
      <div class="flex justify-end">
        <UButton
          type="submit"
          label="Invia il messaggio"
          color="primary"
          :loading="is_submitting"
        />
      </div>
    </div>
  </UForm>
  <p v-if="submitted">
    <span v-if="success"
      >Il tuo messaggio è stato inviato correttamente. Riceverai una risposta al
      più presto.</span
    >
    <span v-else
      >Si è verificato un problema con l'invio del messaggio. Abbiamo ricevuto
      la segnalazione di malfunzionamento. Riprova più tardi.</span
    >
  </p>
</template>
